import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  CreateCombinationSection,
  Input,
  QuestionsList,
  QuestionsListItem,
  SVGButtonWrapper,
  SVGButtonWrapperNormal,
  Section,
  Strong,
  Title
} from './css';
import { Typography } from '@telus-uds/components-web';
import CloseSVG from './fullyManaged/managedITServices/assets/svg/close';
import {
  ButtonWrapper,
  Table,
  Td,
  Th,
  Thead,
  Tr
} from './fullyManaged/managedITServices/components/css';
import DeleteSVG from './fullyManaged/managedITServices/assets/svg/delete';

const CombinationTable = ({ selectedQuestions, setSelectedQuestions }) => {
  const [combinations, setCombinations] = useState([]);
  const [prices, setPrices] = useState({});
  const [savedCombinations, setSavedCombinations] = useState([]);
  const [showTable, setShowTable] = useState(false);

  const generateCombinations = () => {
    const selectedOptions = selectedQuestions.map(question =>
      question.options.map(option => option.text)
    );

    if (selectedOptions.length > 0) {
      const generate = optionsArray => {
        const result = [];

        const helper = (prefix, optionsArray, index) => {
          if (index === optionsArray.length) {
            result.push(prefix);
            return;
          }

          for (const option of optionsArray[index]) {
            helper([...prefix, option], optionsArray, index + 1);
          }
        };

        helper([], optionsArray, 0);
        return result;
      };

      setCombinations(generate(selectedOptions));
      setShowTable(true);
    }
  };

  const handlePriceChange = (rowIndex, type, value) => {
    setPrices(prevPrices => ({
      ...prevPrices,
      [`${rowIndex}-${type}`]: value
    }));
  };

  const handleSaveCombination = () => {
    const combinationWithPrices = combinations.map((combination, index) => ({
      options: combination,
      monthlyPrice: prices[`${index}-monthly`] || '',
      oneTimePrice: prices[`${index}-one-time`] || ''
    }));

    setSavedCombinations([
      ...savedCombinations,
      { questions: selectedQuestions, combinations: combinationWithPrices }
    ]);
    resetForm();
  };

  const resetForm = () => {
    setSelectedQuestions([]);
    setCombinations([]);
    setPrices({});
    setShowTable(false);
  };

  const deleteCombination = index => {
    setSavedCombinations(prevCombinations =>
      prevCombinations.filter((_, i) => i !== index)
    );
  };

  const removeQuestionFromCombination = id => {
    const filteredQuestions = selectedQuestions.filter(
      question => question.id !== id
    );
    setSelectedQuestions(filteredQuestions);
  };

  useEffect(() => {
    // if (selectedQuestions.length <= 1) setShowTable(false);
    // else
    generateCombinations();
  }, [selectedQuestions]);

  return (
    <>
      {selectedQuestions.length > 0 && (
        <CreateCombinationSection>
          <Title>Create Combinations</Title>
          <QuestionsList>
            {selectedQuestions.map(question => (
              <QuestionsListItem key={question.question}>
                <Strong>Q: {question.question}</Strong>
                <SVGButtonWrapper
                  onClick={() => removeQuestionFromCombination(question.id)}
                >
                  <CloseSVG />
                </SVGButtonWrapper>
              </QuestionsListItem>
            ))}
          </QuestionsList>
          {/* <Button
        onClick={generateCombinations}
        disabled={selectedQuestions.length <= 1}
      >
        Create Combination Table
      </Button> */}
          {showTable && combinations.length > 0 && (
            <Container>
              <Table>
                <Thead>
                  <Tr>
                    {selectedQuestions.map(question => (
                      <Th key={question.id}><Typography>{question.question}</Typography></Th>
                    ))}
                    <Th><Typography>Monthly Price</Typography></Th>
                    <Th><Typography>One-time Price</Typography></Th>
                  </Tr>
                </Thead>
                <tbody>
                  {combinations.map((combination, rowIndex) => (
                    <Tr key={rowIndex}>
                      {combination.map((option, optionIndex) => (
                        <Td key={optionIndex}><Typography>{option}</Typography></Td>
                      ))}
                      <Td>
                        <Input
                          type="number"
                          placeholder="Monthly Price"
                          value={prices[`${rowIndex}-monthly`] || ''}
                          onChange={e =>
                            handlePriceChange(
                              rowIndex,
                              'monthly',
                              e.target.value
                            )
                          }
                        />
                      </Td>
                      <Td>
                        <Input
                          type="number"
                          placeholder="One-time Price"
                          value={prices[`${rowIndex}-one-time`] || ''}
                          onChange={e =>
                            handlePriceChange(
                              rowIndex,
                              'one-time',
                              e.target.value
                            )
                          }
                        />
                      </Td>
                    </Tr>
                  ))}
                </tbody>
              </Table>
              <ButtonWrapper>
                <Button
                  onClick={handleSaveCombination}
                  disabled={selectedQuestions.length < 2}
                >
                  Save Combination
                </Button>
                <Button onClick={resetForm}>Clear Current Combination</Button>
              </ButtonWrapper>
            </Container>
          )}
        </CreateCombinationSection>
      )}
      {savedCombinations.length > 0 && (
        <CreateCombinationSection>
          <Title>Combination List</Title>
          {savedCombinations.length > 0 && (
            <Container>
              {savedCombinations.map((savedCombination, index) => (
                <div key={index}>
                  <ButtonWrapper>
                    <Title>Combination {index + 1}</Title>
                    <SVGButtonWrapperNormal
                      onClick={() => deleteCombination(index)}
                    >
                      <DeleteSVG />
                    </SVGButtonWrapperNormal>
                  </ButtonWrapper>

                  <Table>
                    <Thead>
                      <Tr>
                        {savedCombination.questions.map(question => (
                          <Th key={question.id}><Typography>{question.question}</Typography></Th>
                        ))}
                        <Th><Typography>Monthly Price</Typography></Th>
                        <Th><Typography>One-time Price</Typography></Th>
                      </Tr>
                    </Thead>
                    <tbody>
                      {savedCombination.combinations.map(
                        (combination, rowIndex) => (
                          <Tr key={rowIndex}>
                            {combination.options.map((option, optionIndex) => (
                              <Td key={optionIndex}><Typography>{option}</Typography></Td>
                            ))}
                            <Td><Typography>{combination.monthlyPrice}</Typography></Td>
                            <Td><Typography>{combination.oneTimePrice}</Typography></Td>
                          </Tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </div>
              ))}
            </Container>
          )}
        </CreateCombinationSection>
      )}
    </>
  );
};

export default CombinationTable;
